import { ensureSxObject, Typography } from '@arsnovasystems/ars-front-lib';
import { Box, Stack, SxProps, Theme } from '@mui/material';

export const Field = ({
  label,
  EditablePart,
  sx,
}: {
  sx?: SxProps<Theme>;
  label: string;
  EditablePart: React.ReactElement;
}) => {
  return (
    <Stack
      direction={'row'}
      sx={(theme) => ({
        alignItems: 'flex-start',
        ...ensureSxObject(sx, theme),
      })}
    >
      <Typography
        variant={'body2'}
        sx={{
          flex: 3,
          p: 1,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          flex: 7,
        }}
      >
        {EditablePart}
      </Box>
    </Stack>
  );
};
